import { registrarEscenas } from '@/engine/narrative';
import { CAP1_ESCENAS } from './chapters/cap1';
import { CAP2_ESCENAS } from './chapters/cap2';
import { CAP3_ESCENAS } from './chapters/cap3';
import { CAP4_ESCENAS } from './chapters/cap4';
import { CAP5_ESCENAS } from './chapters/cap5';
import { ENDING_ESCENAS } from './endings';

let inicializado = false;

/**
 * Registra todo el contenido narrativo. Idempotente.
 */
export function inicializarContenido(): void {
  if (inicializado) return;
  registrarEscenas([
    ...CAP1_ESCENAS,
    ...CAP2_ESCENAS,
    ...CAP3_ESCENAS,
    ...CAP4_ESCENAS,
    ...CAP5_ESCENAS,
    ...ENDING_ESCENAS,
  ]);
  inicializado = true;
}

export const ESCENA_INICIAL = 'cap1_intro';

/** Para tests: resetea la flag idempotencia. */
export function _resetContenido(): void {
  inicializado = false;
}
